import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findFeedbackList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`gptfeedback/findList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  batchDeletion({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`gptfeedback/deleteByIds`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
}
